import React, { Component } from "react";
import { connect } from "react-redux";
import { withGetScreen } from "react-getscreen";
import { withRouter } from "react-router";
import { formatCurrency } from "../../../../../js/shared/utils";
import { onUpdateQuickSale } from "../../../actions/myOffers";
import InputQuickSale from "../../../../shared/InputQuickSale/InputQuickSale";
import Loading from "../../../../shared/Loading/Loading";
import { refreshOffers, quickSaleClean } from "../../../actions";
import Modal from "../../../../shared/Modal/Modal";
import { logEvent } from "../../../shared/firebase";
import { EditarNaoElegivel, EditarNaoElegivelPagamentoAntecipado } from "../../../services/modals";
import { getPricesForwardPayment, getPricesQuickSale } from "../../../shared/requests-api";

class QuickSale extends Component {
	constructor(props) {
		super(props);
		this.state = {
			quickSaleActived: false,
			newPrice: this.props.offer.price.toString(),
			error: "",
			loading: false,
			maxPrice: 0,
			minPrice: 0,
			openModalFailedSend: false,
			showModalNaoElegivel: false,
			showModalNaoElegivelPagamentoAntecipado: false,
		};

		this.activeQuickSale = this.activeQuickSale.bind(this);
		this.changePriceMiles = this.changePriceMiles.bind(this);
		this.onChangePriceMiles = this.onChangePriceMiles.bind(this);
		this.confirmEdit = this.confirmEdit.bind(this);
		this.scrollToTop = this.scrollToTop.bind(this);
		this.scrollEditPriceMobile = this.scrollEditPriceMobile.bind(this);
		this.validateDynamicRange = this.validateDynamicRange.bind(this);
		this.transformNewPriceForFloat = this.transformNewPriceForFloat.bind(this);
		this.setData = this.setData.bind(this);
	}

	UNSAFE_componentWillMount() {
		this.validateDynamicRange();
	}

	componentDidMount() {
		const { offer, activeQuickSale } = this.props;

		const fetchPricesQuickSale = async () => {
			const result = await getPricesQuickSale();
			const fidelity = result.data.find(r => r.acronym === offer.fidelity.airlineAcronym.toLowerCase()) || {};
			this.setState({ priceQuickSale: fidelity.price });
		};

		const fetchPricesForwardPayment = async () => {
			const result = await getPricesForwardPayment();
			const fidelity = result.data.find(r => r.acronym === offer.fidelity.airlineAcronym.toLowerCase()) || {};
			this.setState({ forwardPayment: fidelity.price });
		};

		if (activeQuickSale)
			this.activeQuickSale();

		if (offer.type == 2)
			fetchPricesQuickSale();

		if (offer.type == 4)
			fetchPricesForwardPayment();
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { hasComponentQuickSaleActive, offer, successSend } = nextProps;

		if (hasComponentQuickSaleActive !== offer.id) {
			this.setData(false);
		}
		this.setState({ successSend: successSend });
	}

	setData(quickSaleActive) {
		this.setState({
			quickSaleActived: quickSaleActive,
			newPrice: this.props.offer.price.toString(),
			error: ""
		});
	}

	validateDynamicRange() {
		const { offer } = this.props;
		let minPrice = offer.fidelity.minPrice;
		// Simplificado com valor dinamico do backend
		let maxPrice = offer.fidelity.maxDynamicPrice || offer.fidelity.maxPrice;

		const fetchPricesQuickSale = async () => {
			const result = await getPricesQuickSale();
			const fidelity = result.data.find(r => r.acronym === offer.fidelity.airlineAcronym.toLowerCase()) || {};
			this.setState({ priceQuickSale: fidelity.price });
		};

		const fetchPricesForwardPayment = async () => {
			const result = await getPricesForwardPayment();
			const fidelity = result.data.find(r => r.acronym === offer.fidelity.airlineAcronym.toLowerCase()) || {};
			this.setState({ forwardPayment: fidelity.price });
		};

		if (offer.type == 2) {
			fetchPricesQuickSale();
		}

		if (offer.type == 4) {
			fetchPricesForwardPayment();
		}

		this.setState({
			minPrice: minPrice,
			maxPrice: maxPrice
		});
	}

	transformNewPriceForFloat(price = this.state.newPrice) {
		let newPrice = price.replace(",", ".");
		newPrice = parseFloat(newPrice.replace(/[^\d.]/g, ""));
		return newPrice;
	}

	confirmEdit() {
		this.onChangePriceMiles(this.state.priceToEdit, true);
		this.setState({ priceToEdit: undefined, showModalNaoElegivel: false });
		this.setState({ priceToEdit: undefined, showModalNaoElegivelPagamentoAntecipado: false });
	}

	onChangePriceMiles(price, ignoreModal) {
		const { offer, onUpdateQuickSale, refreshOffers } = this.props;
		localStorage.removeItem("OfferFilterActive");
		let newPrice = this.transformNewPriceForFloat(price);

		/*
		 * Verificar venda rapida
		 * 1 - Convencional
		 * 2 - Venda Rápida
		 * 4 - Pagamento Antecipado
		 */
		const priceQuickSale = this.state.priceQuickSale || offer.price;
		if (offer.type == 2 && newPrice > priceQuickSale && !ignoreModal) {
			this.setState({ priceToEdit: price, showModalNaoElegivel: true });
			return;
		}

		const forwardPayment = this.state.forwardPayment || offer.price;
		if (offer.type == 4 && newPrice > forwardPayment && !ignoreModal) {
			this.setState({ priceToEdit: price, showModalNaoElegivelPagamentoAntecipado: true });
			return;
		}

		this.setState({ loading: true, newPrice: price });
		onUpdateQuickSale(offer, newPrice)
			.then(() => {
				this.setState({ loading: false });
				if (this.state.successSend) {
					refreshOffers();
				} else {
					this.activeQuickSale();
					this.scrollToTop();
					this.setState({ openModalFailedSend: true });
				}
			})
			.catch(() => {
				this.setState({ newPrice: offer.price });
			});
	}

	activeQuickSale(origin) {
		const { quickSaleActived } = this.state;
		const { setComponentQuickSaleActive, offer, hasComponentQuickSaleActive } = this.props;

		if (!quickSaleActived) {
			logEvent(origin === "field" ? "field_edit_price" : "link_edit_price");
			setComponentQuickSaleActive(offer.id);
			window.isWebview
				? setTimeout(() => this.scrollEditPriceMobile(), 500)
				: this.scrollEditPriceMobile();
		} else {
			setComponentQuickSaleActive(false);
		}
		window.isWebview && !this.activeQuickSale
			? setTimeout(() => setData(), 500)
			: this.setData(!quickSaleActived);
	}

	changePriceMiles(price) {
		const { maxPrice, minPrice } = this.state;
		let newPrice = this.transformNewPriceForFloat(price);

		this.setState({ error: "" });
		if (newPrice < minPrice || newPrice > maxPrice) {
			let message = `O valor deve ser entre ${formatCurrency(minPrice)} e ${formatCurrency(
				maxPrice
			)}`;
			this.setState({ error: message });
		}

		this.setState({ newPrice: price });
	}

	scrollToTop() {
		const { isTablet, isMobile } = this.props;

		if (isTablet() || isMobile()) {
			window.scrollTo({
				top:
					document.querySelector('[data-action="my-offers-new-offer"]').getBoundingClientRect()
						.top +
					window.scrollY -
					65,
				behavior: "smooth"
			});
		} else {
			window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		}
	}

	scrollEditPriceMobile() {
		const { isTablet, isMobile, offer } = this.props;
		const scroll = () => {
			window.scrollTo({
				top:
					document
						.querySelector(`[data-action="quick-sale-component-${offer.id}"]`)
						.getBoundingClientRect().top +
					window.scrollY -
					(window.isWebview ? 100 : 170),
				behavior: "smooth"
			});
		};

		if (isTablet() || isMobile()) {
			scroll();
		}
	}

	onConfirmFailedSend() {
		const { edit, offerInQuickSale, quickSaleClean } = this.props;
		if (offerInQuickSale) {
			edit(offerInQuickSale.offer);
			quickSaleClean();
		}
		this.setState({ openModalFailedSend: false });
	}

	onCancelFailedSend() {
		const { quickSaleClean } = this.props;
		quickSaleClean();
		this.setState({ openModalFailedSend: false });
	}

	render() {
		const {
			quickSaleActived,
			newPrice,
			priceToEdit,
			error,
			loading,
			openModalFailedSend
		} = this.state;
		const { offer, isTablet, isMobile, hasRelationshipPendent, handleOpenEditPrice } = this.props;
		let ruleToAcceptQuickSale =
			offer.editable && offer.allowsFastPrices && !quickSaleActived && !hasRelationshipPendent;

		return (
			<div className="my-sales-quick-sale" data-action={`quick-sale-component-${offer.id}`}>
				{!window.isMobileDevice() && (
					<div className="my-sales-quick-sale--text">1.000 milhas por:</div>
				)}
				<div
					className="my-sales-quick-sale--input"
					data-action={ruleToAcceptQuickSale && "quick-sale-input-edit-price"}
					onClick={() => ruleToAcceptQuickSale && this.activeQuickSale("field")}
				>
					<InputQuickSale
						className="my-sales-quick-sale--input-price"
						onChange={this.changePriceMiles}
						value={priceToEdit || newPrice}
						valSuggestMin={offer.fidelity.valSuggestMin}
						valSuggestMax={offer.fidelity.valSuggestMax}
						decimalSeparator=","
						prefix="R$ "
						placeholder="0"
						maxLength={4}
						disabled={loading || !offer.editable}
						required={quickSaleActived ? quickSaleActived : !quickSaleActived}
						errorMessage={loading || !quickSaleActived ? undefined : error}
						quickSaleActived={quickSaleActived}
						isResponsive={isTablet() || isMobile()}
						ruleToAcceptQuickSale={ruleToAcceptQuickSale}
						activeQuickSale={this.activeQuickSale}
						loading={loading}
						data-action="quick-sale-edit-price"
					/>
				</div>
				{quickSaleActived && (
					<>
						{error != "" ? (
							<div className="my-sales-quick-sale--error-message">
								Mínimo: {formatCurrency(offer.fidelity.minPrice)} e Máximo:{" "}
								{formatCurrency(offer.fidelity.maxPrice)}
							</div>
						) : (
							<div className="my-sales-quick-sale--suggested-value">
								Valor sugerido: <strong>{formatCurrency(offer.fidelity.valSuggestMin)}</strong> a{" "}
								<strong>{formatCurrency(offer.fidelity.valSuggestMax)}</strong>
							</div>
						)}
						<div className="my-sales-quick-sale--button-area">
							{!loading ? (
								<a
									className="cancel"
									onClick={(() => this.activeQuickSale(), handleOpenEditPrice)}
									data-action="quick-sale-cancel-price"
								>
									Cancelar
								</a>
							) : (
								false
							)}
							{!error && !loading && offer.price != this.transformNewPriceForFloat() ? (
								<a
									className="confirm"
									onClick={() => this.onChangePriceMiles(newPrice)}
									data-action="quick-sale-confirm-price"
								>
									Salvar
								</a>
							) : (
								false
							)}
							{loading && <Loading width="100px" height="19px" />}
						</div>
					</>
				)}
				<Modal
					title="Atualize seu cadastro"
					description="A edição rápida de preço não poderá ser utilizada no momento porque alguns dados da sua oferta precisam ser revisados. Quer aproveitar essa facilidade em suas próximas edições? Tente novamente, após concluir o fluxo convencional de edição."
					confirm="Ok, entendi"
					cancel="Cancelar"
					show={openModalFailedSend}
					height={200}
					onConfirm={() => this.onConfirmFailedSend()}
					onCancel={() => this.onCancelFailedSend()}
					fixed={true}
					withoutClose={true}
				/>
				{!!this.state.showModalNaoElegivel && (
					<EditarNaoElegivel
						show={this.state.showModalNaoElegivel}
						onCancel={() => this.setState({ showModalNaoElegivel: false, priceToEdit: undefined })}
						onConfirm={this.confirmEdit}
					/>
				)}
				{!!this.state.showModalNaoElegivelPagamentoAntecipado && (
					<EditarNaoElegivelPagamentoAntecipado
						show={this.state.showModalNaoElegivelPagamentoAntecipado}
						onCancel={() => this.setState({ showModalNaoElegivelPagamentoAntecipado: false, priceToEdit: undefined })}
						onConfirm={this.confirmEdit}
					/>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	data: state.offers.data,
	successSend: state.offers.successSend,
	offerInQuickSale: state.offers.showSendModal,
	quickSaleOffer: state.offers.quickSaleOffer
});

const mapDispatchToProps = dispatch => {
	return {
		onUpdateQuickSale: (offer, newPrice) => dispatch(onUpdateQuickSale(offer, newPrice)),
		refreshOffers: () => dispatch(refreshOffers()),
		quickSaleClean: () => dispatch(quickSaleClean())
	};
};

export default withRouter(
	withGetScreen(connect(mapStateToProps, mapDispatchToProps)(QuickSale), {
		mobileLimit: 468, // TODO Fix screen vars
		tabletLimit: 768, // TODO Fix screen vars
		shouldListenOnResize: true
	})
);
